<template>
  <div class="base-table">
    <el-table
      ref="elTable"
      v-ps="'.el-table__body-wrapper'"
      :data="showData"
      :height="height"
      :max-height="height"
      border
      row-class-name="normal item"
      :cell-class-name="cellClass"
      v-bind="$attrs"
      v-on="$listeners"
      :row-key="rowKey"
    >
      <slot name="table-prefix"></slot>
      <el-table-column v-if="sortable" width="40">
        <template>
          <div class="drag-handler pointer">
            <el-tooltip content="拖拽排序" placement="left">
              <svg-icon icon-class="svgo_drag"></svg-icon>
              <!--<i class="el-icon-sort"></i>-->
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <slot>
        <el-table-column
          v-for="(item, index) in tableColumns"
          :key="index"
          :prop="item.value"
          :label="item.label"
          :width="item.width"
          :min-width="item.minWidth"
          :align="item.align"
        ></el-table-column>
      </slot>
      <slot name="table-suffix"></slot>
    </el-table>
    <Pagination
      class="mTop10"
      v-if="showPagination"
      :pageInfo="pageInfo"
      :cell-size-visible="true"
      @cellSizeChange="cellSizeChange"
      @pageChange="$emit('pageChange', $event)"
    ></Pagination>
  </div>
</template>

<script>
import Pagination from "./pagination"
import Sortable from "sortablejs"

export default {
  name: "BaseTable",
  components: {
    Pagination
  },
  props: {
    tableColumns: Array,
    tableData: Array,
    tableHeight: {
      type: [Number, String],
      default: 0
    },
    pageInfo: Object,
    showPagination: {
      type: Boolean,
      default: true
    },
    rowKey: [String, Function],
    sortable: {
      type: Boolean,
      default: false
    },
    from: String
  },
  computed: {
    height() {
      if (this.showPagination && this.from != "app") return `calc(${this.tableHeight} - 42px)`
      return this.tableHeight
    },
    showData() {
      if (!this.showPagination) return this.tableData
      return this.tableData.slice(
        (this.pageInfo.currentPage - 1) * this.pageInfo.pageSize,
        this.pageInfo.currentPage * this.pageInfo.pageSize
      )
    }
  },
  data() {
    return {
      cellClass: "normal"
    }
  },
  mounted() {
    if (this.sortable) {
      if (!this.rowKey) {
        // el-table使用rowKey来绑定行,如果不传,则默认使用数组索引,会导致和Sortable冲突
        console.error("使用sortable功能时,rowKey必填")
        return
      }
      const el = this.$el.querySelectorAll(".el-table__body-wrapper tbody")[0]
      Sortable.create(el, {
        disabled: false, // 是否开启拖拽
        ghostClass: "sortable-ghost", // 拖拽样式
        animation: 150, // 拖拽延时，效果更好看
        handle: ".drag-handler",
        draggable: ".item",
        group: { pull: false, put: false },
        onEnd: ({ newIndex, oldIndex }) => {
          if (this.showPagination) {
            newIndex += (this.pageInfo.currentPage - 1) * this.pageInfo.pageSize
            oldIndex += (this.pageInfo.currentPage - 1) * this.pageInfo.pageSize
          }
          let data = this.tableData
          data.splice(newIndex, 0, ...data.splice(oldIndex, 1))
          this.$emit("change", data)
        }
      })
    }
  },
  methods: {
    cellSizeChange(size) {
      this.cellClass = size
    }
  }
}
</script>

<style lang="scss" scoped>
$table-header-height: 42px;
.base-table {
  ::v-deep {
    .el-table__fixed-header-wrapper,
    .el-table__header-wrapper {
      height: $table-header-height;
      thead {
        th {
          padding: 0 !important;
          height: $table-header-height;
          background-color: #f9f7fa;
        }
      }
    }
    .el-table__fixed {
      height: 100% !important;
      .el-table__fixed-body-wrapper {
        height: calc(100% - #{$table-header-height}) !important; // 解决滚动条透明问题
      }
    }
    .el-table__fixed-right {
      height: 100% !important;
      right: 0 !important;
      .el-table__fixed-body-wrapper {
        height: calc(100% - #{$table-header-height}) !important; // 解决滚动条透明问题
      }
    }
    .ps__rail-x {
      z-index: 100;
    }
    .ps__rail-y {
      z-index: 100;
    }
    .el-table__body-wrapper {
      position: relative;
      overflow: hidden;
    }
    .small {
      padding: 0 !important;
      height: 32px !important;
      line-height: 32px !important;
    }
    .normal {
      padding: 0 !important;
      height: 40px !important;
      line-height: 40px !important;
    }
    .large {
      padding: 0 !important;
      height: 52px !important;
      line-height: 52px !important;
      .cell,
      .el-table--border {
        padding-left: 20px !important;
        padding-right: 20px !important;
      }
    }
    .drag-handler {
      font-size: 18px;
      text-align: center;
    }
  }
}

// .el-table .cell,
// .el-table th div,
// .el-table--border td:first-child .cell,
// .el-table--border th:first-child .cell {
//   padding-left: 10px;
// }
</style>
